module.exports = __webpack_public_path__ + "f5bbe5beb6460ec435fa374ee7d4460b.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-48.cur
// module id = 461
// module chunks = 0